<template>
  <div class="popup" :class="{show:show}">
    <!-- <div class="mask"></div> -->
    <div class="content">
      <div class="title-box">
        <div class="title">预约洽谈</div>
        <div class="close" @click="close"><i class="el-icon-close"></i></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  props:{
    img:{type:String,default:''},
    show:{type:Boolean,default:false}
  },
  computed:{
    background(){
      return {}
    }
  },
  methods:{
    close(){
      this.$emit('close',false);
    }
  }
}
</script>

<style scoped>
.popup{position:fixed; display:flex; top:0; bottom:0; right:0; left: 12.5%; background:rgba(0,0,0,.5); z-index:9999; transition-duration:300ms; opacity:0; visibility:hidden;}
.popup.show{opacity:1; visibility:visible;}
.popup .content{background:#fff; display:inline-block; margin:auto; min-width:50vw; transition-duration:300ms; transform:scale(.6);}
.popup.show .content{transform:scale(1);}
.popup .content .title-box{padding:0.6vw 0.5vw 0.6vw 1vw; height:2vw; line-height:2vw; display: flex; justify-content: space-between;}
.popup .content .title-box .title{font-weight:bold;}
.popup .content .title-box .close{font-size:2vw; color:#333; cursor:pointer; transition-duration:300ms;}
.popup .content .title-box .close:hover{transform: rotate(90deg);}

@media (max-width:991px){

}
</style>